import { Pencil, Trash2 } from "lucide-react";
import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";
import { type PartialSkill } from "~/services/skills";

export interface SkillRowProps {
  skill: PartialSkill;
  canEdit: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export const SkillRow = ({ skill, canEdit, onEdit, onDelete }: SkillRowProps) => (
  <li
    className={cn(
      "group flex items-center gap-3 px-4 py-3",
      "first:rounded-t-lg last:rounded-b-lg",
      canEdit && "hover:bg-accent/30"
    )}
  >
    <div className="min-w-0 flex-1">
      <p className="text-sm font-medium">{skill.name}</p>
      {skill.description && (
        <p className="mt-0.5 text-xs text-muted-foreground">{skill.description}</p>
      )}
    </div>

    {canEdit && (
      <div
        className={cn(
          "flex shrink-0 items-center gap-1",
          "opacity-0 transition-opacity group-hover:opacity-100 focus-within:opacity-100"
        )}
      >
        <Button
          variant="ghost"
          size="icon"
          className="size-7"
          aria-label={`Edit ${skill.name}`}
          onClick={onEdit}
        >
          <Pencil className="size-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="size-7 text-muted-foreground hover:text-destructive"
          aria-label={`Remove ${skill.name}`}
          onClick={onDelete}
        >
          <Trash2 className="size-4" />
        </Button>
      </div>
    )}
  </li>
);
